export const termsURLs = {
  choice: 'https://www.choicehotels.com/legal/terms-of-use',
  ihg: 'https://www.ihg.com/content/us/en/customer-care/tc',
  radisson: 'https://www.radissonhotels.com/en-us/terms-and-conditions',
  wyndham:
    'https://www.wyndhamhotels.com/about-us/privacy-notice-more-info?lightbox=/content/whg-ecomm-responsive/en-us/whg/about-us/terms-of-use-more-info.display.html'
}

export const privacyURLs = {
  choice: 'https://www.choicehotels.com/legal/privacy-policy',
  ihg: 'https://www.ihg.com/content/us/en/customer-care/privacy_statement',
  radisson: 'https://www.radissonhotels.com/en-us/privacy',
  wyndham: 'https://www.wyndhamhotels.com/about-us/privacy-notice-more-info'
}

// global

export const BEs = {
  choicehotels: 'choicehotels',
  ihg: 'ihg',
  resnexus: 'resnexus',
  synxis: 'synxis',
  travelclick: 'travelclick',
  travelclick_v2: 'travelclick_v2',
  radissonhotels: 'radissonhotels',
  wyndhamhotels: 'wyndhamhotels',
  marriott: 'marriott',
  hilton: 'hilton',
  windsurfer: 'windsurfer',
  bestwestern: 'bestwestern',
  hyatt: 'hyatt',
  microsdc: 'microsdc',
  guestcentric: 'guestcentric',
  webrez: 'webrez',
  reztrip: 'reztrip',
  stayntouch: 'stayntouch',
  visualmatrix: 'visualmatrix',
  sonesta: 'sonesta',
  skipper: 'skipper',
  cloudbeds: 'cloudbeds',
  karismahotels: 'karismahotels',
  lark: 'lark',
  hotelKey: 'hotelkey'
}

export const BEsUsingPromoCode = [
  BEs.webrez,
  BEs.guestcentric,
  BEs.marriott,
  BEs.microsdc,
  BEs.pegasus,
  BEs.radissonhotels,
  BEs.hyatt,
  BEs.guestcentric
]

export const BENames = {
  choicehotels: 'choicehotels.com',
  ihg: 'ihg.com',
  resnexus: 'Resnexus',
  synxis: 'Synxis',
  travelclick: 'TravelClick',
  radissonhotels: 'radissonhotels.com',
  wyndhamhotels: 'wyndhamhotels.com',
  marriott: 'marriott.com',
  hilton: 'hilton.com',
  windsurfer: 'Windsurfer',
  bestwestern: 'Best Western',
  hyatt: 'Hyatt',
  microsdc: 'MicroSDC',
  guestcentric: 'GuestCentric',
  webrez: 'Webrez',
  travelclick_v2: 'TravelClick v2',
  cloudbeds: 'Cloudbeds',
  karismahotels: 'Karisma Hotels',
  lark: 'Lark'
}

export const indieBEs = {
  resnexus: 'Resnexus',
  synxis: 'Synxis',
  microsdc: 'MisroSDC',
  travelclick: 'TravelClick',
  travelclick_v2: 'TravelClick v2',
  windsurfer: 'Windsurfer',
  'direct-book': 'Direct Book',
  stayntouch: 'StayNtouch',
  pegasus: 'Pegasus',
  reztrip: 'RezTrip',
  webrez: 'Webrez',
  guestcentric: 'GuestCentric',
  redroof: 'Redroof',
  visualmatrix: 'Visual Matrix',
  skipper: 'Skipper',
  cloudbeds: 'Cloudbeds',
  destiworld: 'Destiworld',
  karismahotels: 'Karisma Hotels',
  ihg: 'ihg.com',
  lark: 'Lark',
  mews: 'Mews',
  hotelkey: 'HotelKey',
  choicehotels: 'choicehotels.com'
}

export const PMSs = {
  choiceadvantage: 'choiceadvantage',
  operadefault: 'operadefault',
  opera: 'opera',
  resnexus: 'resnexus',
  skytouch: 'skytouch',
  stayntouch: 'stayntouch',
  stayntouchapi: 'stayntouchapi',
  webrezpro: 'webrezpro',
  // fosse: 'Fosse',
  // onq: 'OnQ',
  unknown: 'unknown',
  visualmatrix: 'visualmatrix',
  marriottgxp: 'marriottgxp',
  roomkey: 'roomkey',
  htng: 'htng',
  jonaschorum: 'jonaschorum',
  pep: 'pep',
  ohip: 'ohip',
  clock: 'clock',
  roommaster: 'roommaster',
  maestro: 'maestro',
  infor: 'infor',
  cloudbeds: 'cloudbeds',
  destiworld: 'destiworld',
  synxis: 'synxis',
  mews: 'mews',
  hotelkey: 'hotelkey'
}

export const PMSnames = {
  choiceadvantage: 'ChoiceAdvantage',
  opera: 'Opera Custom',
  operadefault: 'Opera Default',
  resnexus: 'Resnexus',
  skytouch: 'Skytouch',
  stayntouch: 'StayNtouch',
  stayntouchapi: 'StayNtouch API',
  webrezpro: 'WebrezPro',
  // fosse: 'Fosse',
  // onq: 'OnQ',
  //disconnected: 'Disconnected',
  unknown: ' Unknown',
  visualmatrix: 'Visual Matrix',
  marriottgxp: 'Marriott GXP',
  roomkey: 'RoomKeyPMS',
  htng: 'HTNG',
  jonaschorum: 'Jonas Chorum',
  pep: 'Hilton PEP',
  ohip: 'Opera OHIP',
  clock: 'Clock',
  roommaster: 'RoomMaster',
  maestro: 'Maestro',
  infor: 'Infor',
  cloudbeds: 'Cloudbeds',
  destiworld: 'Destiworld',
  synxis: 'Synxis',
  mews: 'Mews',
  hotelkey: 'HotelKey'
}

export const indiePMSs = {
  opera: 'Opera',
  resnexus: 'Resnexus',
  skytouch: 'Skytouch',
  webrezpro: 'WebrezPro',
  stayntouch: 'StayNtouch',
  visualmatrix: 'Visual Matrix',
  htng: 'HTNG',
  roommaster: 'RoomMaster',
  maestro: 'Maestro',
  infor: 'Infor',
  cloudbeds: 'Cloudbeds',
  destiworld: 'Destiworld',
  mews: 'Mews',
  hotelkey: 'HotelKey'
}

// ihg

export const ihgChainURLKeys = {
  crowneplaza: 'CP',
  holidayinnclubvacations: 'CV',
  candlewood: 'CW',
  holidayinnexpress: 'EX',
  holidayinn: 'HI',
  intercontinental: 'IC',
  hotelindigo: 'IN',
  kimptonhotels: 'KI',
  armyhotels: 'MA',
  holidayinnresorts: 'RS',
  staybridge: 'SB',
  hualuxe: 'UL',
  evenhotels: 'VN',
  avidhotels: 'va',
  voco: 'vx'
}

export const ihgChains = {
  crowneplaza: 'Crowne Plaza',
  holidayinnclubvacations: 'Club Vacations',
  candlewood: 'CandleWood Suites',
  holidayinnexpress: 'Holiday inn Express',
  holidayinn: 'Holiday inn',
  intercontinental: 'InterContinental',
  hotelindigo: 'Hotel Indigo',
  kimptonhotels: 'Kimpton',
  armyhotels: 'Army Hotels',
  holidayinnresorts: 'Holiday inn Resort',
  staybridge: 'Staybridge Suites',
  hualuxe: 'HUALUXE brand',
  evenhotels: 'EVEN Hotels',
  avidhotels: 'Avid Hotels',
  voco: 'vx'
}

export const wyndhamChains = {
  'wyndham-grand': 'Wyndham Grand',
  dolce: 'Dolce',
  wyndham: 'Wyndham',
  tryp: 'TRYP',
  esplendor: 'Esplendor',
  dazzler: 'Dazzler',
  trademark: 'Trademark',
  laquinta: 'La Quinta',
  wingate: 'Wingate',
  'wyndham-garden': 'Wyndham Garden',
  americinn: 'Americinn',
  ramada: 'Ramada',
  baymont: 'Baymont',
  travelodge: 'Travelodge',
  microtel: 'Microtel',
  'days-inn': 'Days Inn',
  'super-8': 'Super 8',
  hojo: 'Howard Johnson',
  hawthorn: 'Hawthorn Suites'
}

export const hyattChains = {
  place: 'Hyatt Place',
  urcove: 'UrCove',
  andaz: 'Andaz',
  alila: 'Alila',
  thompson: 'Thompson Hotels',
  centric: 'Hyatt Centric',
  unbound: 'The Unbound Collection',
  destination: 'Destination Hotels',
  jdv: 'Joie de Vivre Hotels',
  park: 'Park Hyatt',
  grand: 'Grand Hyatt',
  regency: 'Hyatt Regency',
  house: 'Hyatt House',
  hyatt: 'Hyatt'
}

export const choiceChains = {
  'quality-inn': 'Quality Hotels',
  'clarion-hotel': 'Clarion Hotels',
  'sleep-inn': 'Sleep Hotels',
  'comfort-inn': 'Comfort Hotels',
  ascend: 'Ascend Hotels',
  'rodeway-inn': 'Rodeway Hotels',
  'econo-lodge': 'Econo Lodge Hotels',
  'mainstay-suites': 'MainStay Suites',
  cambria: 'Cambria Hotels',
  suburban: 'Suburban Extended Stay',
  'country-inn-suites-hotels': 'Country Inn & Suites',
  'radisson-hotels': 'Radisson Hotels',
  'radisson-blu-hotels': 'Radisson Blu Hotels'
}

export const radissonChains = {
  radisson: 'Radisson',
  'radisson-blu': 'Radisson BLU',
  'radisson-red': 'Radisson RED',
  'park-plaza': 'Park Plaza',
  'park-inn': 'Park Inn by Radisson',
  'country-inn': 'Country Inn & Suites'
}

export const marriottChains = {
  'marriott-hotels': 'Mariott Hotels',
  'springhill-suites': 'Springhill Suites',
  'residence-inn': 'Residence Inn',
  westin: 'Westin',
  'towneplace-suites': 'Towneplace Suites',
  courtyard: 'Courtyard',
  fairfield: 'Fairfield',
  'autograph-collection': 'Autograph collection',
  'le-meridien': 'Le Meridien',
  sheraton: 'Sheraton',
  'tribute-portfolio': 'Tribute Portfolio',
  'ac-hotels': 'AC Hotels',
  aloft: 'Aloft Hotels',
  'element-hotels': 'Element Hotels',
  'renaissance-hotels': 'Renaissance Hotels'
}

export const bestwesternChains = {
  'bw-premier-collection': 'BW Premier Collection',
  'best-western-signature-collection': 'Best Western Signature Collection',
  'best-western-plus': 'Best Western Plus',
  'best-western': 'Best Western'
}

export const hiltonChains = {
  hampton: 'Hampton',
  'hilton-garden-inn': 'Hilton Garden Inn',
  'homewood-suites': 'Homewood Suites',
  'embassy-suites': 'Embassy Suites',
  tru: 'Tru by Hilton',
  doubletree: 'DoubleTree',
  'tapestry-collection': 'Tapestry Collection',
  'curio-collection': 'Curio Collection',
  home2: 'Home2 Suites',
  spark: 'Spark by Hilton'
}

export const sonestaChains = {
  'royal-sonesta': 'Royal Sonesta',
  'sonesta-hotels-resorts': 'Sonesta Hotels & Resorts',
  'sonesta-select': 'Sonesta Select',
  'sonesta-es-suites': 'Sonesta ES Suites',
  'sonesta-simply-suites': 'Sonesta Simply Suites',
  'sonesta-essential': 'Sonesta Essential',
  'red-lion-suites': 'Red Lion Suites',
  'red-lion-hotels': 'Red Lion Hotels'
}

export const parentChains = {
  radisson: 'radisson',
  choice: 'choice',
  ihg: 'ihg',
  wyndham: 'wyndham',
  marriott: 'marriott',
  hilton: 'hilton',
  independent: ' independent',
  hyatt: 'hyatt',
  bestwestern: 'bestwestern',
  sonesta: 'sonesta'
}

export const parentChainNames = {
  radisson: 'Radisson',
  choice: 'Choice',
  ihg: 'IHG',
  wyndham: 'Wyndham',
  marriott: 'Marriott',
  hilton: 'Hilton',
  independent: ' Independent',
  hyatt: 'Hyatt',
  bestwestern: 'Best Western',
  sonesta: 'Sonesta'
}

export const subChains = {
  'quality-inn': [
    'quality-hotel',
    'quality-hotel-suites',
    'quality-inn',
    'quality-inn-suites',
    'quality-resort',
    'quality-suites'
  ],
  'clarion-hotel': [
    'clarion-hotel',
    'clarion-hotel-suites',
    'clarion-inn',
    'clarion-inn-suites',
    'clarion-resort',
    'clarion-suites'
  ],
  'sleep-inn': ['sleep-inn', 'sleep-inn-suites'],
  'comfort-inn': [
    'comfort-hotel',
    'comfort-inn',
    'comfort-inn-suites',
    'comfort-hotel-suites'
  ],
  'rodeway-inn': ['rodeway-inn', 'rodeway-inn-suites'],
  'econo-lodge': ['econo-lodge', 'econo-lodge-inn-suites']
}

export const brandVariants = [
  'La Quinta Inn & Suites by Wyndham',
  'Microtel Inn & Suites by Wyndham',
  'Country Inn & Suites by Radisson',
  'SureStay Plus By Best Western',
  'Holiday Inn Express & Suites',
  'Biltmore Hotel and Suites',
  'Best Western Inn & Suites',
  'Homewood Suites by Hilton',
  'Embassy Suites by Hilton',
  'Econo Lodge Inn & Suites',
  'Quality Hotel & Suites',
  'Suburban Extended Stay',
  'Home2 Suites by Hilton',
  'Courtyard by Marriott',
  'Travelodge by Wyndham',
  'Comfort Inn & Suites',
  'Sleep Inn & Suites',
  'Holiday Inn & Suites',
  'Quality Inn & Suites',
  'Hampton Inn & Suites',
  'Holiday Inn Express',
  'Days Inn by Wyndham',
  'Wingate by Wyndham',
  'Candlewood Suites',
  'Staybridge Suites',
  'MainStay Suites',
  'Comfort Suites',
  'Quality Suites',
  'Wyndham Garden',
  'Wyndham Grand',
  'Tru by Hilton',
  'Cambria Hotel',
  'Hotel Indigo',
  'Crowne Plaza',
  'Comfort Inn',
  'Holiday Inn',
  'Best Western',
  'Quality Inn',
  'Hyatt Place',
  'Hyatt House',
  'avid hotels',
  'Hampton Inn',
  'The Westin',
  'EVEN Hotel',
  'Sleep Inn',
  'Courtyard',
  'Radisson',
  'Sheraton',
  'Marriott',
  'Wyndham',
  'Aloft',
  'Hyatt'
]
